import { useMutation } from "@apollo/client";
import { ADD_COMMENT_CRAWLER } from "graphql/facebookCrawler/mutation";
import { toast } from "react-toastify";

export const useAddFacebookCrawler = (t: Function, setIsSubmittingSaveDraft: Function, closeFrom: Function) => {
  const [addCommentCrawler, { loading: addCommentCrawlerLoading }] = useMutation(ADD_COMMENT_CRAWLER, {
    onError: () => {
      toast.error(`${t("facebookAutoEngagement.toast.fail")}`, {
        position: toast.POSITION.TOP_CENTER,
        closeButton: false,
        autoClose: 2000,
      });
      setIsSubmittingSaveDraft(false);
    },
    onCompleted: () => {
      toast.success(t("facebookAutoEngagement.toast.complete"), {
        position: toast.POSITION.TOP_CENTER,
        closeButton: false,
        autoClose: 3000,
      });
      closeFrom(false);
      setIsSubmittingSaveDraft(false);
    },
  });

  return { addCommentCrawler, addCommentCrawlerLoading };
};
